import { AxiosResponsePromise } from '@seiue/axios'
import { createContext, useContext } from 'react'

import {
  FieldDomainEnum,
  FieldGroupRes,
  InformalReflection,
  InformalReflectionReq,
} from 'packages/sdks-next/growp'

/**
 * 用户详情 context
 */
export const UserDetailContext = createContext<{
  id: number
  domain: FieldDomainEnum
  groupsData: FieldGroupRes[] | null
  updateInfo?: ({
    id,
    payload,
  }: {
    id: number
    payload: InformalReflectionReq
  }) => AxiosResponsePromise<InformalReflection>
}>({
  id: 0,
  domain: FieldDomainEnum.InformalTeacher,
  groupsData: [],
})

/**
 * 获取用户详情 context
 *
 * @returns 获取用户详情 context
 */
export function useUserDetailContext() {
  const context = useContext(UserDetailContext)
  if (!context) {
    throw new Error('AnswersContext not exsist')
  }
  return context
}
